import DeliveryContainerRoutes from './delivery_container';

export default [...DeliveryContainerRoutes];
